<div class="grid">
    <div class="col-12">
        <form>
            <p-card header="Update Driver Details">
                <p-messages [(value)]="messages" [closable]="true" />
                <div class="p-fluid p-formgrid grid" [formGroup]="driverForm">
                    <div class="field col-12 md:col-4 mb-0">
                        <label htmlFor="firstname" class="text-sm text-500"
                            >First Name</label
                        >
                        <input
                            type="text"
                            id="firstname"
                            placeholder="First Name"
                            pInputText
                            formControlName="firstname"
                        />
                    </div>
                    <div class="field col-12 md:col-4 mb-0">
                        <label htmlFor="surname" class="text-sm text-500"
                            >Surname</label
                        >
                        <input
                            type="text"
                            id="surname"
                            placeholder="Surname"
                            pInputText
                            formControlName="surname"
                        />
                    </div>
                    <div class="field col-12 md:col-4 mb-0">
                        <label htmlFor="dob" class="text-sm text-500"
                            >Date Of Birth</label
                        >
                        <p-calendar
                            [disabledDates]="dateValidator.invalidDates"
                            [maxDate]="dateValidator.maxDate"
                            #dob
                            placeholder="Date Of Birth"
                            formControlName="dateOfBirth"
                        >
                        </p-calendar>
                    </div>
                    <div class="field col-12 md:col-4">
                        <label htmlFor="gender" class="text-sm text-500"
                            >Gender</label
                        >
                        <p-dropdown
                        
                            #gender
                            formControlName="gender"
                            optionLabel="name"
                            optionValue="value"
                            [options]="genderTypes"
                            placeholder="Select Gender Type"
                        >
                        </p-dropdown>
                    </div>
                    
                </div>
                <ng-template class="align-items-right" pTemplate="footer">
                    <div class="flex gap-2 mt-1">
                        <p-button
                            icon="pi pi-times-circle"
                            pRipple
                            label="Clear"
                            (click)="clearForm()"
                            severity="secondary"
                        />

                        <button
                            icon="pi pi-check"
                            label="Save"
                            severity="primary"
                            pTooltip="Save Driver Details"
                            (click)="saveDriverDetails()"
                            pButton
                            pRipple
                        ></button>
                    </div>
                </ng-template>
            </p-card>
        </form>
    </div>
</div>

